export default __webpack_public_path__ + "static/media/Montserrat-ExtraBold.f7ed659b.woff";